module.exports = __webpack_public_path__ + "static/media/Python.b9bbb1d7.png";